<svelte:head>
    <meta name="description" content="Statistics for Stadia games and prices.">
    <title>Stats - StadiaDB</title>
</svelte:head>

<script>
    import { FirebaseApp, Doc, Collection } from 'sveltefire';

    export let currency;
</script>

<Doc let:traceId path={'pages/stats'} let:ref let:data={data} let:error>
    {#if data.note != ''}
    <div class="full-width notice">
        <p>{@html data.note}</p>
    </div>
    {/if}

    <div slot="fallback">
        <div class="full-width notice">
            <p><strong>oh god oh fuck.</strong> Something went wrong, you're not supposed to see this.</p>
        </div>
    </div>
</Doc>

<Doc let:traceId path={'stats/all'} let:ref let:data={data}>
    <h2 style="margin-bottom: 0;">Statistics</h2>
    <sup>Updated daily.</sup>

    <p>
        <strong>Total Entries:</strong> {data.total}<br />
        <strong>Games:</strong> {data.games}<br />
        <strong>Bundles:</strong> {data.bundles}<br />
        <strong>Addons:</strong> {data.addons}<br />
        <strong>Subscriptions:</strong> {data.subscriptions}<br />
        <br /><br />
        <strong>Price of everything:</strong> {currency.symbol}{data.prices[currency.shorthand].toFixed(2)}<br />
        <strong>Price of all games:</strong> {currency.symbol}{data.gamePrices[currency.shorthand].toFixed(2)}<br />
        <strong>Price of all bundles:</strong> {currency.symbol}{data.bundlePrices[currency.shorthand].toFixed(2)}<br />
        <strong>Price of all addons:</strong> {currency.symbol}{data.addonPrices[currency.shorthand].toFixed(2)}<br />
        <br /><br />
        <strong>Average game:</strong> {currency.symbol}{data.averageGame[currency.shorthand].toFixed(2)}<br />
        <strong>Average bundle:</strong> {currency.symbol}{data.averageBundle[currency.shorthand].toFixed(2)}<br />
        <strong>Average addon:</strong> {currency.symbol}{data.averageAddon[currency.shorthand].toFixed(2)}<br />
        <br /><br />
        {#if data.gamesDelisted > 0}<strong>Games delisted:</strong> {data.gamesDelisted}<br />{/if}
        {#if data.bundlesDelisted > 0}<strong>Bundles delisted:</strong> {data.bundlesDelisted}<br />{/if}
        {#if data.addonsDelisted > 0}<strong>Addons delisted:</strong> {data.addonsDelisted}<br />{/if}
        {#if data.subscriptionsDelisted > 0}<strong>Subscriptions delisted:</strong> {data.subscriptionsDelisted}<br />{/if}
        <sup>Delisted items are not removed, just games or bundles which are no longer available for purchase. Typically items which contained a pre-order or limited time bonus.</sup>
    </p>
</Doc>

<style>
    .notice {
        background: #eeeeee;
        padding: 10px;
        padding-left: 5vw;
        padding-right: 5vw;
        width: 90vw;
    }

    :global(main.dark) .notice {
        background: #212121;
    }
</style>